import React , {useEffect, useState} from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {getBooks, deleteBook} from '../../actions/book';
import {getRequests, deleteRequest } from '../../actions/request';
import {sendMail} from '../../actions/mail';
import { IoIosSend } from 'react-icons/io';
import {FiEdit} from 'react-icons/fi';
import {RiDeleteBin7Line} from 'react-icons/ri';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import {Modal} from 'react-bootstrap';
import SearchMaps from '../HomePage/SearchMaps.js';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Background from './bookstore.png';
import {Tooltip, OverlayTrigger } from 'react-bootstrap';

function Alert(props) {
  return <MuiAlert elevation={7} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  table: {
    minWidth: 700,
},
}));

// Modal
function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter">
          Send Email
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Dear {props.bookInfo?.provider?.split(" ")[0]}, <br />
          I found your email from the Bookstore application online. I was really interested in the book {props.bookInfo.name} written by {props.bookInfo.author}. Can you please lend me your book if you do not need it at the moment? My email address is {props.myProfile?.result.email}.
          <br />  <br />
          Sincerely,
          <br />
          {props.myProfile?.result.name} 
          <br />
          {props.myProfile?.result.collegeName} 
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.sendmail}>Send</Button>
      </Modal.Footer>
    </Modal>
  );
}


const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: '#1c2e4a',
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#a7c9f2',
      },
    },
  }))(TableRow);




const Contents = ({mybooks, myrequests, setCurrentId, checkedStatus}) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    
    const [modalShow, setModalShow] = React.useState(false);
    const [stateValue, setStateValue] = React.useState('');
    const [selectedBook, setSelectedBook] = React.useState({});
    const [open2, setOpen2] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(3);
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [open, setOpen] = React.useState(false);

     
    const myProfile = JSON.parse(localStorage.getItem('profile'));
    const books = useSelector((state) => state.mybooks);
    const sentId = useSelector((state)=> state.mailsent);
    const info = window.location.href.split("/");
    const currentPage =  info[info.length - 1];
  

    navigator.geolocation.getCurrentPosition(function(position) {
      setLatitude(position.coords.latitude);
      setLongitude(position.coords.longitude);
    });

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      
    };

    let listIds = []
    sentId.map((sent)=>{
        listIds = listIds.concat(sent)
    })
    
    useEffect (()=>{
      if (currentPage === "mybooks") {
        dispatch(getBooks());
      }else if (currentPage === "myrequests"){
        dispatch(getRequests());
      }
    }, [])
    
    const sendmail = () =>{
      const mailInformation = {bookId: selectedBook._id, receiverName: selectedBook.provider.split(" ")[0], receiverEmail: selectedBook.email, bookName: selectedBook.name, authorName: selectedBook.author, senderName: myProfile?.result.name, senderCollege: myProfile?.result.collegeName, senderEmail: myProfile?.result.email}
      dispatch(sendMail(mailInformation));
      setOpen(true)
      setModalShow(false);
    }

    const handleClick = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
    }
      setOpen(false);
    };

    const handleClick2 = () => {
      setOpen2(true);
    };

    const handleClose2 = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen2(false);
    };
    
    const goToHomepage = () =>{
      history.push('/');
    }
        
    return (
        <div> 
          {!myProfile && goToHomepage()}
          <MyVerticallyCenteredModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                  bookInfo = {selectedBook}
                  myProfile = {myProfile}
                  sendmail = {sendmail}
                  stateValue = {stateValue}
                  setStateValue = {setStateValue}
          />
          {!checkedStatus ? 
          <>
            <Container>
                <Snackbar open={open2} autoHideDuration={7000} onClose={handleClose2}>
                  <Alert onClose={handleClose2} severity="error">
                      Your {currentPage === 'mybooks'?  <> book </> : <> request </> } has been deleted! 
                  </Alert>
                </Snackbar> 
                <Snackbar open={open} autoHideDuration={7000} onClose={handleClose}>
                  <Alert onClose={handleClose} severity="success">
                    Your mail has been sent! 
                  </Alert>
                </Snackbar>
                {!books.length ? 
                  <div> 
                    <React.Fragment>
                      <CssBaseline />
                      <Container>
                        <Typography component="div" style={{backgroundImage: `url(${Background})`, backgroundPosition: "center",  height: '77vh'}} >
                          <h3> No entries found! {currentPage !== 'mybooks' && currentPage !== 'myrequests' && <>Search web, instead.</>}</h3>
                        </Typography>
                      </Container>
                    </React.Fragment> 
                  </div> 
                :  
                  <Row>
                    <Col sm={12}>
                      <Paper className={classes.root}>
                        <TableContainer className = {classes.container}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell align ="left">Book Name and Edition</StyledTableCell>
                                <StyledTableCell align = "right">Author's Name</StyledTableCell>                  
                                {!myrequests && <StyledTableCell align = "right">Condition</StyledTableCell>}
                                <StyledTableCell align="right">Subject</StyledTableCell>
                                <StyledTableCell align="right">Professor</StyledTableCell>
                                {!mybooks && !myrequests && <StyledTableCell align="right">College Name</StyledTableCell>}
                                {!myrequests && <StyledTableCell align="right">Notes</StyledTableCell>}
                                {!myrequests && <StyledTableCell align="right">Exam Materials</StyledTableCell>}
                                {!mybooks &&
                                <StyledTableCell align="right">Provider's Name</StyledTableCell>}
                                { !mybooks &&
                                <StyledTableCell align="right">Send Email</StyledTableCell>}
                                {mybooks && <StyledTableCell align="right">Modify/Delete</StyledTableCell>}
                              </TableRow>
                            </TableHead>     
                            <TableBody>
                              {books.slice(page * 7, page * 7 + 7).map((book) => (
                                <StyledTableRow key={book.name}>  
                                <StyledTableCell component="th" scope="row">
                                  {book.name}
                                </StyledTableCell>
                                <StyledTableCell align = "right">
                                  {book.author}
                                </StyledTableCell>
                                {!myrequests &&< StyledTableCell align="right">{book.condition}</StyledTableCell>}
                                <StyledTableCell align="right">{book.subject}</StyledTableCell>
                                <StyledTableCell align="right">{book.professor}</StyledTableCell>
                                {!myrequests && !mybooks && <StyledTableCell align="right">{book.college}</StyledTableCell>}
                                
                                {!myrequests && <StyledTableCell align="right">{book.notes}</StyledTableCell>}
                                {!myrequests && < StyledTableCell align="right">{book.exam}</StyledTableCell>}
                                {!myrequests && !mybooks && < StyledTableCell align="right">{book.provider}</StyledTableCell>}
                                {!mybooks && <StyledTableCell align="right">
                                {listIds.includes(book._id) ? 
                                  <OverlayTrigger
                                    key={book._id}
                                    placement={'right'}
                                    overlay={
                                      <Tooltip id={`tooltip-${'right'}`}>
                                        You can only send one email for any book.
                                      </Tooltip>
                                    }
                                  >
                                  <span>
                                    <Button disabled onClick = {() => {
                                      setSelectedBook(book)
                                      setModalShow(true)}} 
                                      variant="outline-primary"
                                    >
                                      <IoIosSend />
                                    </Button>
                                  </span>
                                  </OverlayTrigger> 
                                :
                                  <Button onClick = {() => {
                                    setSelectedBook(book)
                                    setModalShow(true)}} 
                                    variant="outline-primary"
                                    >
                                      <IoIosSend />
                                  </Button>
                                }
                                </StyledTableCell>}
                                {mybooks && <StyledTableCell align="right"><Button onClick = {()=> setCurrentId(book._id)} variant="outline-primary"><FiEdit /> </Button> {}
                                <Button onClick = {() => {
                                  setOpen2(true)
                                  currentPage === "mybooks" ? dispatch(deleteBook(book._id)): dispatch(deleteRequest(book._id)) 
                                  }} variant="outline-danger"><RiDeleteBin7Line /> </Button></StyledTableCell>}
                              </StyledTableRow>
                            ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <TablePagination
                        rowsPerPageOptions={[7]}
                        component="div"
                        count={books.length}
                        rowsPerPage={7}
                        page={page}
                        onChangePage={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        />  
                     </Paper>
                    </Col>
                  </Row>
                }
              </Container>
            </> 
          : 
            <>
<             SearchMaps books = {books} latitude = {latitude} longitude = {longitude} /> </>
          }
      </div>
    )
}

export default Contents
